define('ordersDetailOrderProductOptionEditMixableOptionsFooterView',[
  'module',
  'modalFooterView',
  'buttonView',
  'underscore',
  'template!ordersDetailOrderProductOptionEditMixableOptionsFooterView'
], function (
  Module,
  ModalFooterView,
  ButtonView,
  _,
  Tpl
) {
  'use strict';

  Module.exports = ModalFooterView.extend({
    template: Tpl,
    className: 'footer-view',

    regions: _.extend({}, ModalFooterView.prototype.regions, {
      addRegion: '.add-region'
    }),

    onRender: function() {
      ModalFooterView.prototype.onRender.call(this);

      //----------------
      this.addView = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('common.add'),
        title: _.i18n('common.add')
      });
      this.getRegion('addRegion').show(this.addView);
      this.addView.on('click', _.bind(function () {
        this.trigger('add');
      }, this));    
    }
  });
});
